import { z } from "zod";

export const GeoRegionSchema = z.object({
    id: z.number().int().positive(),
    label: z.string(),
    slug: z.string(),
    sort_index: z.number().int().nonnegative(),
});

export const GeoRegionsSchema = z.array(GeoRegionSchema);

export type GeoRegion = z.infer<typeof GeoRegionSchema>;
export type GeoRegions = z.infer<typeof GeoRegionsSchema>;
